import { ConfettiIcon } from "@phosphor-icons/react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { hooks } from "@/services/api/hooks";

export function CompletionStep() {
  const userId = useBoundStore(useShallow((state) => state.user.id));
  const { data: profile } = hooks.profiles.useFetchProfile(userId);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-2 text-center">
      <ConfettiIcon className="text-5xl" />
      <p className="mt-3 text-lg font-semibold">Setup Complete!</p>
      <p>
        {profile?.name ? (
          <>
            <span className="font-semibold">{profile.name}</span>, are you ready to start creating and organizing your
            notes?
          </>
        ) : (
          "Are you ready to start creating and organizing your notes?"
        )}
      </p>
    </div>
  );
}
